<template>
  <div>
    <component :is="size" :id="block.id">{{ block.value.heading_text }}</component>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
const {block} = defineProps<{block: SphereBlock<'heading_block'>}>();
const size = computed(() => (block.value.size ? block.value.size : 'h1'));
</script>
